/** @format */
// Migrated from AngularJS: tutoring.route.js
import { Transition } from '@uirouter/core';
import { SisPlanMessagesComponent, SisStateDeclaration } from 'sis-components';
import { TutoringPlansComponent } from './tutoring-plans/tutoring-plans.component';

const tutoringRootState = 'student.logged-in.plan.tutoring';
const tutoringMessagesState = 'student.logged-in.plan.tutoring.messages';
const tutoringNewMessagesState = 'student.logged-in.plan.tutoring.new-messages';

export const tutoringStates: SisStateDeclaration[] = [
    {
        name: tutoringRootState,
        url: '/tutoring',
        component: TutoringPlansComponent,
    },
    {
        name: tutoringMessagesState,
        url: '/messages',
        component: SisPlanMessagesComponent,
        resolve: {
            validatablePlan: getValidatablePlan,
        },
        bindings: {
            plan: 'selectedPlan',
        },
    },
    {
        name: tutoringNewMessagesState,
        url: '/new-messages',
        component: SisPlanMessagesComponent,
        resolve: {
            validatablePlan: getValidatablePlan,
        },
        bindings: {
            plan: 'selectedPlan',
        },
    },
];

export function getValidatablePlan($transition$: Transition): Promise<any> {
    const injector = $transition$.injector();
    return injector.get('PlanLoader').createValidatablePlan(injector.get('selectedPlan'));
}

getValidatablePlan.$inject = ['$transition$'];
